import React from "react";
import "./avatar.css";

const Avatar = () => {
  return (
    <div className="avatar">
      <img src="assets/images/my-pic.jpeg" alt="avatar" />
    </div>
  );
};

export default Avatar;
